import React from 'react';
import PropTypes from 'prop-types';
import { Typography, FlexBox } from '@vp/swan';

export const CustomTextDisplay = ({ attribute }) => (
  <FlexBox justifyContent="space-between">
    {attribute.label ? (
      <Typography component="label" fontWeight="bold">
        {attribute.label}:
      </Typography>
    ) : null}
    <Typography color="dark-grey" marginBottom="2">
      {attribute.data}
    </Typography>
  </FlexBox>
);
CustomTextDisplay.propTypes = {
  attribute: PropTypes.object.isRequired,
};
